import { useState } from "react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import { Pause, Play } from "@phosphor-icons/react";

export default function HoldResumeControl({ candidate, onChange }) {
  const [busy, setBusy] = useState(false);
  const [reasonOpen, setReasonOpen] = useState(false);
  const [reason, setReason] = useState("");

  const doHold = async () => {
    if (!reason.trim()) { toast.error("Please enter a reason"); return; }
    setBusy(true);
    try { await api.post(`/candidates/${candidate.id}/hold`, { hold_reason: reason }); toast.success("Service on hold"); setReasonOpen(false); setReason(""); onChange?.(); }
    catch (ex) { toast.error(formatApiError(ex.response?.data?.detail)); }
    finally { setBusy(false); }
  };
  const doResume = async () => {
    setBusy(true);
    try { const r = await api.post(`/candidates/${candidate.id}/resume`, {}); toast.success(`Resumed · +${r.data.days_added} days added`); onChange?.(); }
    catch (ex) { toast.error(formatApiError(ex.response?.data?.detail)); }
    finally { setBusy(false); }
  };

  const isHold = candidate.service_status === "Hold";
  return (
    <div className="inline-flex items-center gap-2">
      {isHold ? (
        <button onClick={doResume} disabled={busy} data-testid="resume-service-btn"
                className="inline-flex items-center gap-1 text-xs bg-emerald-600 hover:bg-emerald-700 text-white px-3 py-1.5 rounded-md">
          <Play size={12} weight="fill" /> Resume Service
        </button>
      ) : (
        <>
          <button onClick={() => setReasonOpen(true)} disabled={busy} data-testid="hold-service-btn"
                  className="inline-flex items-center gap-1 text-xs bg-amber-600 hover:bg-amber-700 text-white px-3 py-1.5 rounded-md">
            <Pause size={12} weight="fill" /> Hold Service
          </button>
          {reasonOpen && (
            <div className="fixed inset-0 bg-black/30 backdrop-blur-sm grid place-items-center p-4 z-50">
              <div className="bg-white border border-slate-200 rounded-xl p-6 w-full max-w-md">
                <h3 className="font-semibold mb-3">Put Service on Hold</h3>
                <label className="text-xs text-slate-500">Reason</label>
                <textarea rows={3} value={reason} onChange={(e) => setReason(e.target.value)} data-testid="hold-reason-input"
                          className="w-full border border-slate-200 rounded-md px-3 py-2 text-sm mt-1" />
                <div className="flex justify-end gap-2 mt-4">
                  <button onClick={() => setReasonOpen(false)} className="px-4 py-2 text-sm rounded-md border border-slate-200">Cancel</button>
                  <button onClick={doHold} disabled={busy} data-testid="confirm-hold" className="px-4 py-2 text-sm rounded-md bg-amber-600 hover:bg-amber-700 text-white disabled:opacity-60">Confirm Hold</button>
                </div>
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
}
